import { render, staticRenderFns } from "./SpacingHorizontal.vue?vue&type=template&id=14655894&scoped=true"
import script from "./SpacingHorizontal.vue?vue&type=script&lang=js"
export * from "./SpacingHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14655894",
  null
  
)

export default component.exports